import { GridLegacy } from "@mui/material";
import React, { useRef, useState } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import Buttonbar from "./Custombuttons/Components/Buttonbar";
import Overzicht from "./Custombuttons/Components/Overzicht";

//Form
import Menukaart from "./Custombuttons/InputForms/Menukaart";
import { useController } from "react-hook-form";
import FormJson from "../../../components/Forms/FormJson";

function CustomButton() {
  const [showInputForm, setShowInputForm] = useState(false);

  const form = useRef(null);

  const {
    field: { value: customButtonValue, onChange: customButtonOnChange },
  } = useController({ name: "customButton" });

  const handleButtonClick = (type) => {
    form.current = getInputForm(type);
    setShowInputForm(true);
  };

  const handleCloseClick = () => {
    form.current = null;
    setShowInputForm(false);
  };

  const onDelete = (objectToDelete) => {
    customButtonOnChange(
      JSON.stringify(JSON.parse(customButtonValue).filter((obj) => obj.name !== objectToDelete.name))
    );
  };

  const handleEdit = (row) => {
    form.current = getInputForm(row.type, row);
    setShowInputForm(true);
  };

  const getInputForm = (type, value = undefined) => {
    let form = null;
    let action = "ADD";
    if (value !== undefined) {
      action = "EDIT";
    }

    switch (type) {
      case "menukaart":
        form = (
          <Menukaart
            closeForm={handleCloseClick}
            onSave={(value) => {
              const arr = customButtonValue ? JSON.parse(customButtonValue) : [];
              if (action === "ADD") {
                arr.push(value);
              } else if (action === "EDIT") {
                arr.forEach((obj, key) => {
                  if (obj.name === value.oldName) {
                    delete value.oldName;
                    arr[key] = value;
                  }
                });
              }
              customButtonOnChange(JSON.stringify(arr));
            }}
            value={value}
          />
        );
        break;
    }

    return form;
  };

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <Buttonbar disableAll={showInputForm} onClick={handleButtonClick} />
            </GridLegacy>
          </GridLegacy>

          {form.current}

          <Overzicht
            customFields={customButtonValue}
            disableAll={showInputForm}
            onDelete={onDelete}
            onEdit={handleEdit}
          />

          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"JSON"} tKey={"vestigingen.form.custombuttons.headers.json"} />
              </h3>
            </GridLegacy>
            <FormJson
              name={"customButton"}
              tDefault={"Custom button JSON"}
              tKey={"vestigingen.form.custombuttonjson.label.customButton"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default CustomButton;
